var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedJobs.length > 1
    ? _c("div", { staticClass: "bulk-section" }, [
        _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.selectedJobs.length))]),
          _vm._v(
            "\n        job" +
              _vm._s(_vm.selectedJobs.length > 1 ? "s" : "") +
              " selected.\n    "
          ),
        ]),
        _c(
          "div",
          [
            _c(
              "md-button",
              {
                staticClass: "md-round md-just-icon md-primary",
                attrs: { title: "Recalculate jobs" },
                on: { click: _vm.bulkRecalculate },
              },
              [_c("md-icon", [_vm._v("currency_exchange")])],
              1
            ),
            _c(
              "md-button",
              {
                staticClass: "md-round md-just-icon md-success",
                attrs: { title: "Approve jobs" },
                on: { click: _vm.bulkApprove },
              },
              [_c("md-icon", [_vm._v("thumb_up")])],
              1
            ),
            _c(
              "md-button",
              {
                staticClass: "md-round md-just-icon md-danger",
                attrs: { title: "Unapprove jobs" },
                on: { click: _vm.bulkUnapprove },
              },
              [_c("md-icon", [_vm._v("thumb_down")])],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }